var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":_vm.colspan}},[_c('i',{staticClass:"fas fa-database",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"ml-1"},[_vm._v("Empty List")])])}
var staticRenderFns = []

export { render, staticRenderFns }